import { NgModule } from '@angular/core';
import { ComponentsModule } from './components/components.module';


@NgModule({
  declarations: [],
  imports: [
  ],
  exports: [
    ComponentsModule,
  ]
})
export class ATComponentsModule { }
